import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PersonalTaskDataService {
  public tasksChanged = new Subject<void>();

  notifyChanged(): void {
    this.tasksChanged.next();
  }
}
